/**
 * CaseNumbers section
 */
(function referencesFrontend($, CountUp, window) {
    $(document).on('cms.ready', ready);

    let $section;
    let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.


    const observerOptions = {
        root: null, // relative to document viewport
        rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: .5 // visible amount of item shown in relation to root
    };


    function ready() {
        $section = $('.sectionCaseNumbers');

        logged_in = $('body.logged-in').length;
        if (logged_in) return; // do not wrap and count up for admins

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if(entry.isIntersecting) {
                    let $elm = $(entry.target);

                    // save initial value
                    if (!$elm.data('number')) {
                        $elm.data('number', $elm.text());
                    }

                    countUpValue($elm.data('number'), entry.target);
                }
            });
        }, observerOptions);

        $('.case-numbers__number strong', $section).each((idx, elm) => observer.observe(elm));
    }

    function countUpValue(text, elm){
        // Parse text to fit our requirements (we need a number)
        let decimal_separator = ',';
        let number_separator = '.';

        text = text.replace(/[^\d,]/g,'').replace(decimal_separator,number_separator)


        // Find amount of decimals
        let decimals = 0;
        if(text.indexOf(number_separator) >= 0) {
            decimals = text.length - (text.indexOf(number_separator) + 1)
        }

        // Finally actually parse/covert to a number
        let number = parseFloat(text);

        let options = {
            startVal: 0,
            decimalPlaces: decimals,
            duration: 3,
            separator: number_separator,
            decimal: decimal_separator
        };

        let countUp = new CountUp(elm, number, options);
        countUp.start();
    }

})(jQuery, CountUp, window);
